var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerImgWithBg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 116.989,
    viewBox: "0 0 130 116.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_176975",
    "data-name": "Group 176975",
    transform: "translate(12137 10442)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145101",
    "data-name": "Rectangle 145101",
    width: 130,
    height: 100,
    transform: "translate(-12137 -10442)",
    fill: "#c50f3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_176974",
    "data-name": "Group 176974",
    transform: "translate(-12137 -10442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29999",
    "data-name": "Path 29999",
    d: "M-19.11,0V-8.46h3.7a3.242,3.242,0,0,1,2.064.582,1.947,1.947,0,0,1,.732,1.614,1.984,1.984,0,0,1-.348,1.176,1.993,1.993,0,0,1-.96.72,2.113,2.113,0,0,1,1.122.714,2.02,2.02,0,0,1,.4,1.29,2.12,2.12,0,0,1-.762,1.746A3.275,3.275,0,0,1-15.282,0Zm1.476-4.872h1.956q1.572,0,1.572-1.212T-15.678-7.3h-1.956Zm0,3.708h2.16q1.584,0,1.584-1.272t-1.584-1.272h-2.16ZM-9.066.12A2.527,2.527,0,0,1-10.2-.126a1.963,1.963,0,0,1-.78-.666,1.662,1.662,0,0,1-.282-.948,1.489,1.489,0,0,1,.336-1.026,2.006,2.006,0,0,1,1.092-.546A9.736,9.736,0,0,1-7.806-3.48h.42v-.252A1.188,1.188,0,0,0-7.65-4.6a1.227,1.227,0,0,0-.888-.264,3.6,3.6,0,0,0-1.008.15,4.561,4.561,0,0,0-1.044.462l-.432-1.02a3.442,3.442,0,0,1,.738-.378,5.318,5.318,0,0,1,.9-.252,4.8,4.8,0,0,1,.894-.09,2.68,2.68,0,0,1,1.908.594,2.436,2.436,0,0,1,.624,1.842V0h-1.4V-.936a1.638,1.638,0,0,1-.648.774A1.928,1.928,0,0,1-9.066.12Zm.312-1.032a1.3,1.3,0,0,0,.978-.408,1.433,1.433,0,0,0,.39-1.032v-.264h-.408a4.794,4.794,0,0,0-1.566.174.63.63,0,0,0-.438.63.838.838,0,0,0,.276.648A1.1,1.1,0,0,0-8.754-.912ZM-4.434,0V-5.868H-2.97v.912a2,2,0,0,1,.81-.768,2.456,2.456,0,0,1,1.146-.264q2.076,0,2.076,2.412V0h-1.5V-3.5A1.556,1.556,0,0,0-.7-4.5a.976.976,0,0,0-.8-.312,1.374,1.374,0,0,0-1.05.414,1.536,1.536,0,0,0-.39,1.1V0Zm7.02,0V-5.868H4.05v.912a2,2,0,0,1,.81-.768,2.456,2.456,0,0,1,1.146-.264q2.076,0,2.076,2.412V0h-1.5V-3.5a1.556,1.556,0,0,0-.258-1,.976.976,0,0,0-.8-.312,1.374,1.374,0,0,0-1.05.414,1.536,1.536,0,0,0-.39,1.1V0ZM12.5.12a3.7,3.7,0,0,1-1.716-.372,2.644,2.644,0,0,1-1.11-1.056,3.217,3.217,0,0,1-.39-1.62,3.247,3.247,0,0,1,.378-1.6A2.778,2.778,0,0,1,10.7-5.6a2.948,2.948,0,0,1,1.518-.39A2.546,2.546,0,0,1,14.2-5.2a3.074,3.074,0,0,1,.726,2.16v.444h-4.2a1.6,1.6,0,0,0,1.8,1.572,3.359,3.359,0,0,0,.984-.15,2.7,2.7,0,0,0,.9-.474l.42,1.008a3.138,3.138,0,0,1-1.056.552A4.144,4.144,0,0,1,12.5.12Zm-.216-5.088a1.444,1.444,0,0,0-1.068.408,1.815,1.815,0,0,0-.492,1.1h2.952a1.8,1.8,0,0,0-.4-1.122A1.269,1.269,0,0,0,12.282-4.968ZM16.11,0V-5.868h1.464v1.032a1.959,1.959,0,0,1,1.848-1.152l.456-.036.1,1.272-.864.084q-1.476.144-1.476,1.512V0Z",
    transform: "translate(65 63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sub-volume",
    transform: "translate(53 17.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11379",
    "data-name": "Path 11379",
    d: "M25.408,19.028l-4.936-3.1,4.936-3.1a1.079,1.079,0,0,0,0-1.75L14.332,4.119a.745.745,0,0,0-.808,0L2.448,11.076a1.079,1.079,0,0,0,0,1.75l4.936,3.1-4.936,3.1a1.079,1.079,0,0,0,0,1.75l11.076,6.958a.746.746,0,0,0,.808,0l11.076-6.958a1.079,1.079,0,0,0,0-1.75ZM13.928,6.123l9.279,5.829L13.928,17.78,4.649,11.952Zm0,19.609L4.649,19.9l4.532-2.847,4.343,2.728a.746.746,0,0,0,.808,0l4.343-2.728L23.207,19.9Z",
    transform: "translate(-2 -4)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_29951",
    "data-name": "Path 29951",
    d: "M2.092,0H23.013L0,23.013V2.092A2.092,2.092,0,0,1,2.092,0Z",
    transform: "translate(-12072 -10357.557) rotate(45)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImgWithBg3);
export default __webpack_public_path__ + "static/media/BannerImgWithBG (3).6016e2d3246ffafb2d42a81c4c3b9ceb.svg";
export { ForwardRef as ReactComponent };